export class TipoCupon {

 constructor(public idTipoCupon: number, public descripcion: string){}

}
